import { useDismissToast, useToasts } from '@/shared/lib/toast'
import { Toast, ToastProvider } from '@/shared/ui'

/**
 * Рисует очередь тостов. Сама очередь — в `shared/lib/toast`: класть её сюда нельзя, потому что
 * `toast.error()` зовёт `MutationCache` (`app/providers/query-client.ts`), а он живёт вне дерева
 * компонентов и импортировать виджет не может.
 *
 * Тост закрывается тремя способами — крестиком, свайпом и сам через 5 секунд (`duration` у
 * `ToastProvider`). Все три приходят одним и тем же `onOpenChange(false)`, поэтому убирать из
 * очереди достаточно в одном месте: иначе закрытый свайпом тост остался бы в памяти навсегда.
 */
export function Toaster() {
  const items = useToasts()
  const dismiss = useDismissToast()

  return (
    <ToastProvider>
      {items.map((item) => (
        <Toast
          key={item.id}
          tone={item.tone}
          title={item.title}
          description={item.description}
          requestId={item.requestId}
          report={item.report}
          onOpenChange={(open) => {
            if (!open) dismiss(item.id)
          }}
        />
      ))}
    </ToastProvider>
  )
}
